module.exports = __webpack_public_path__ + "media/images/img-hobby-13-b09d0570.jpg";